var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExchangeBanner = function SvgExchangeBanner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 444,
    height: 70,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ExchangeBanner_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M434 0H10C4.477 0 0 4.477 0 10v50c0 5.523 4.477 10 10 10h424c5.523 0 10-4.477 10-10V10c0-5.523-4.477-10-10-10Z",
    fill: "url(#ExchangeBanner_svg__b)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "ExchangeBanner_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(43.059 42.331 36.761) scale(292.203 1393.72)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A7CD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F1830"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ExchangeBanner_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h444v70H0z"
  })))));
};
export default SvgExchangeBanner;